<template>
  <div class="user-form">
    <toolbar
      :backRoute="-1"
      :hideBackButton="forcePasswordChange"
      title="Change your password"
      saveButtonLabel="Save changes"
      saveButtonEvent="password-change-save"
      :saveInProgress="saveInProgress" />

    <d-container fluid class="common-form px-0 pt-5 pb-5">
      <d-form>
        <validation-observer ref="change-password-form" tag="form">
          <d-row>
            <d-col cols="6" class="ml-auto mr-auto">
              <div class="form-group">
                <label for="password">Password:</label>

                <validation-provider
                  rules="required|strong_password"
                  name="password"
                  v-slot="{ errors }">
                  <d-input
                    v-model="data.password"
                    type="password"
                    :state="errors.length ? 'invalid' : null" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label for="password_confirmation">Confirm password:</label>

                <validation-provider
                  rules="required|password:password|strong_password"
                  name="password_confirmation"
                  v-slot="{ errors }">
                  <d-input
                    v-model="data.password_confirmation"
                    type="password"
                    :state="errors.length ? 'invalid' : null" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>
          </d-row>
        </validation-observer>
      </d-form>
    </d-container>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import HasChangesDetection from './../../mixins/HasChangesDetection.vue';

export default {
  name: 'change-password-form',
  mixins: [
    HasChangesDetection
  ],
  computed: {
    forcePasswordChange () {
      if (this.$route.params.type === 'force') {
        return true;
      }

      return false;
    }
  },
  data () {
    return {
      data: {
        password: '',
        password_confirmation: ''
      },
      saveInProgress: false
    };
  },
  mounted () {
    this.$bus.$on('password-change-save', this.validateForm);
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['change-password-form'], this.submitForm);
    },
    submitForm () {
      let endpointUrl = '/profile/change-password';

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: this.data,
        successTitle: 'Password changed',
        successText: 'The password has been successfully saved!',
        errorTitle: 'An error occurred!',
        errorText: 'The operation not finished successfully. Please try again.',
        successAction: () => {
          let potentialRedirect = window.crmGetRedirect();

          if (potentialRedirect) {
            this.$router.push(potentialRedirect);
          } else {
            window.location.href = '/dashboard/';
          }
        }
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('password-change-save', this.validateForm);
  }
}
</script>
